// Press testimonials — quotes from event programmers, producers, hosts,
// brand activations. Drop new entries in here; the /press page picks them
// up automatically. Empty array renders the section's zero state.
//
// Schema:
//   quote        — the pull quote (no surrounding quote marks — page adds them)
//   attribution  — name of the speaker
//   role         — title + org, e.g. "Programming Director, D23 Expo"
//   highlight    — optional 4-8 word lead-in pulled out larger; can be omitted
//   logo         — optional logo image: { src, alt }
//                  src should be a path under /public, e.g. "press/d23-logo.png"
//   photo        — optional headshot of the speaker: { src, alt }
//                  src should be a path under /public, e.g.
//                  "press/testimonials/jane-doe.jpg"
//
// Display: 3–5 testimonials show at a time once populated.
export const PRESS_TESTIMONIALS = [
  {
    highlight: "Extremely popular with guests of all ages.",
    quote: "We saw Daniel's pancake art from Instagram and knew immediately that it would be a great addition to our family-friendly events. Daniel was a pleasure to work with from start to finish, and the live pancake artist demonstration was extremely popular with guests of all ages.",
    attribution: "Huiyuan Liu",
    role: "Tianyu Arts & Culture Inc. · Dragon Lights Reno",
  },
  // Example shape — copy + edit when adding more:
  // {
  //   highlight: "The room couldn't look away.",
  //   quote: "Dan turned a corner of the lobby into the most-photographed spot of the weekend. Guests stopped mid-conversation. Programmers asked me for his contact before he'd flipped his second pancake.",
  //   attribution: "Jane Doe",
  //   role: "Programming Director, Some Big Festival",
  //   logo: { src: "press/big-festival-logo.png", alt: "Some Big Festival" },
  //   photo: { src: "press/testimonials/jane-doe.jpg", alt: "Jane Doe portrait" },
  // },
];
